import { CalendarTodayOutlined, FemaleOutlined, LocationOnOutlined, MaleOutlined } from '@mui/icons-material';
import { Avatar, Grid, Typography } from '@mui/material';
import { CaleculateAge } from 'components/helpers';
import dayjs from 'dayjs';
import * as React from 'react';


const PatientInformation = ({appointment_information}) =>{

    const {patient_info_gender : gender,
        patient_info_first_name : first_name,
        patient_info_last_name : last_name,
        patient_info_second_name : second_name,
        patient_info_city : city,
        patient_info_birthday: birthday,
        patient_info_address : address} = appointment_information ;

    
    const calculatedAge =birthday ? CaleculateAge(birthday) : null ;

    return (
        
            <>
            <Grid item container direction="column" xs={12 } alignItems="center">
                    <Avatar alt={first_name} sx={{width:'8rem',height:'8rem'}} />

                    <Typography variant="h6" align="center"  sx={{display: 'flex',alignItems: 'center',justifyContent:'center',gap:1}}> 
                      {Boolean(gender) == false ? <FemaleOutlined style={{color:'#FF69B4'}}/> : <MaleOutlined style={{color:'#279BFF'}}/>} 

                       {`${first_name || ''} ${second_name || ''} ${last_name || ''}`} 
                    </Typography>
            </Grid>
            <Grid item container xs={10} justifyContent="center" rowGap={3}>

                    { dayjs(birthday).isValid() && 

                        <Grid item container  xs={8} columnGap={1}>
                            <CalendarTodayOutlined  style={{color:'#279BFF'}}/> 

                            {`${dayjs(birthday).format('DD/MM/YYYY').toString()}`} 
                            {calculatedAge && `(${calculatedAge.year}.${calculatedAge.month})`}

                        </Grid>
                    }

                    {address && 
                        <Grid item container xs={8} columnGap={1}>
                            <LocationOnOutlined style={{color:'#279BFF'}}/>
                            {`${city || ''}${city && address ? `, ${address} `:(address || '') }`}
                        </Grid>
                    }
            </Grid>

                    </>
    );
};

export default PatientInformation ;